<div *ngIf="fieldTechnician" class="container-fluid">
    <form #form="ngForm" (ngSubmit)="saveFieldTechnician(form)">
        <div mat-dialog-title>
            <div *ngIf="fieldTechnician.fieldTechnician_ID" i18n>Edit Field Technician</div>
            <div *ngIf="!fieldTechnician.fieldTechnician_ID" i18n>Add Field Technician</div>
        </div>
        <div mat-dialog-content>
            <div class="mb-3">
                <div *ngIf="fieldTechnician.resource_ID" i18n>Make the necessary changes on the form below then click Submit</div>
                <div *ngIf="!fieldTechnician.resource_ID" i18n>To add a new resource, complete the form below then click Submit.</div>
                <div class="float-right warning col-sm-4" i18n>* Required Information</div>
            </div>
            <div class="clearfix"></div>

            <div class="form-group row">
                <div class="col-sm-12 form-inline">
                    <div class="control-wrapper">
                        <label class="pr-2" for="firstName"><span class="warning">* </span><span i18n>First Name</span></label>
                        <div>
                            <input name="firstName" class="form-control" type="text"
                                   [(ngModel)]="fieldTechnician.fieldTechnician_FirstName" required #firstName="ngModel"
                                   [class.field-error]="form.submitted && firstName.invalid">
                            <div [hidden]="!form.submitted || firstName.valid"
                                 class="alert alert-danger" i18n>
                                First Name is invalid
                            </div>
                        </div>
                    </div>
                    <div class="control-wrapper">
                        <label class="pr-2" for="lastName"><span class="warning">* </span><span i18n>Last Name</span></label>
                        <div>
                            <input name="lastName" class="form-control" type="text"
                                   [(ngModel)]="fieldTechnician.fieldTechnician_LastName" required #lastName="ngModel"
                                   [class.field-error]="form.submitted && lastName.invalid" />
                            <div [hidden]="!form.submitted || lastName.valid"
                                 class="alert alert-danger" i18n>
                                Last Name is invalid
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-12 form-inline">
                    <div class="control-wrapper">
                        <label class="pr-2" for="hourlyRate" i18n>Hourly Rate</label>
                        <div>
                            <input name="hourlyRate" class="form-control" type="number"
                                   [(ngModel)]="fieldTechnician.fieldTechnician_HourlyRate" #hourlyRate="ngModel"
                                   [class.field-error]="form.submitted && hourlyRate.invalid">
                            <div [hidden]="!form.submitted || hourlyRate.valid"
                                 class="alert alert-danger" i18n>
                                Hourly Rate is invalid
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="mt-3">
                <div [hidden]="!form.submitted || form.valid"
                     class="alert alert-danger" i18n>
                    Validation issues encountered.  Please review your entered information.
                </div>
            </div>
        </div>
        <div mat-dialog-actions>
            <button type="submit" value="submit" name="submit" id="submit" [disabled]="isRequesting" class="btn btn-bidit-submit btn-md mr-3" i18n>Submit</button>
            <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md" i18n>Cancel</a>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
    </form>
</div>


